<template lang="">
    <div v-if="kioskInfo.type === 'W'">
        <WeddingKioskFormType1 v-if="$route.query.kioskStyle === '1'" :invitationSeq = kioskInfo.invitationSeq :weddingInfo = kioskInfo.weddingInfo />
        <WeddingKioskFormType2 v-if="$route.query.kioskStyle === '2'" :invitationSeq = kioskInfo.invitationSeq :weddingInfo = kioskInfo.weddingInfo />
        <WeddingKioskFormType3 v-if="$route.query.kioskStyle === '3'" :invitationSeq = kioskInfo.invitationSeq :weddingInfo = kioskInfo.weddingInfo />
        <WeddingKioskFormType4 v-if="$route.query.kioskStyle === '4'" :invitationSeq = kioskInfo.invitationSeq :weddingInfo = kioskInfo.weddingInfo />
    </div>
    <div v-if="kioskInfo.type === 'F'">
        <FuneralKioskFormType1 v-if="$route.query.kioskStyle === '1'" :invitationSeq = kioskInfo.invitationSeq :funeralInfo = kioskInfo.funeralInfo />
        <FuneralKioskFormType2 v-if="$route.query.kioskStyle === '2'" :invitationSeq = kioskInfo.invitationSeq :funeralInfo = kioskInfo.funeralInfo />
        <FuneralKioskFormType3 v-if="$route.query.kioskStyle === '3'" :invitationSeq = kioskInfo.invitationSeq :funeralInfo = kioskInfo.funeralInfo />
        <FuneralKioskFormType4 v-if="$route.query.kioskStyle === '4'" :invitationSeq = kioskInfo.invitationSeq :funeralInfo = kioskInfo.funeralInfo />
    </div>
</template>

<script>
// import WeddingKioskForm from '@/components/kiosk/WeddingKioskForm.vue';
import WeddingKioskFormType1 from '@/components/kiosk/WeddingKioskFormType1.vue';
import WeddingKioskFormType2 from '@/components/kiosk/WeddingKioskFormType2.vue';
import WeddingKioskFormType3 from '@/components/kiosk/WeddingKioskFormType3.vue';
import WeddingKioskFormType4 from '@/components/kiosk/WeddingKioskFormType4.vue';
// import FuneralKioskForm from '@/components/kiosk/FuneralKioskForm.vue';
import FuneralKioskFormType1 from '@/components/kiosk/FuneralKioskFormType1.vue';
import FuneralKioskFormType2 from '@/components/kiosk/FuneralKioskFormType2.vue';
import FuneralKioskFormType3 from '@/components/kiosk/FuneralKioskFormType3.vue';
import FuneralKioskFormType4 from '@/components/kiosk/FuneralKioskFormType4.vue';
import { mapActions, mapState } from 'vuex';

const invitationModule = 'invitationModule'

export default {
    // data () {
    //     return {
    //         kioskInfo: {
    //             type: 'F'
    //         }
    //     }
    // },

    props: {
        orderNum: {
            type: Number,
            required: true,
        }
    },

    components: {
        // WeddingKioskForm,
        WeddingKioskFormType1,
        WeddingKioskFormType2,
        WeddingKioskFormType3,
        WeddingKioskFormType4,
        // FuneralKioskForm,
        FuneralKioskFormType1,
        FuneralKioskFormType2,
        FuneralKioskFormType3,
        FuneralKioskFormType4
    },

    methods: {
        ...mapActions(invitationModule, ['requestKioskData'])
    },

    computed: {
        ...mapState(invitationModule, ['kioskInfo'])
    },

    async mounted () {
        const isCampaign = await this.requestKioskData(this.orderNum)
        if (!isCampaign) {
            this.$router.push({ name: 'home' })
        }
    }

}
</script>
<style lang="">

</style>